import React from "react";

const ScrollableContainer = ({
  children,
  className = "",
  style = {},
  paddingRight = "4px",
  ...props
}) => {
  return (
    <div
      className={`flex-1 overflow-y-auto overflow-x-hidden tree-scroll min-h-0 ${className}`}
      style={{
        scrollbarWidth: "auto",
        scrollbarColor: "var(--panel-border) var(--panel-surface)",
        height: "100%",
        paddingRight,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default ScrollableContainer;
